import wordmarkOnDark from '@/assets/brand/betr-wordmark-on-dark.png';
import wordmarkOnLight from '@/assets/brand/betr-wordmark-on-light.png';
import markOnDark from '@/assets/brand/betr-mark-on-dark.png';
import markOnLight from '@/assets/brand/betr-mark-on-light.png';

const SOURCES = {
  onDark: { wordmark: wordmarkOnDark, mark: markOnDark },
  onLight: { wordmark: wordmarkOnLight, mark: markOnLight },
} as const;

const ASPECT = {
  wordmark: 828 / 300,
  mark: 278 / 300,
} as const;

type BrandLogoProps = {
  tone?: keyof typeof SOURCES;
  variant?: 'wordmark' | 'mark';
  height?: number;
  className?: string;
};

export default function BrandLogo({
  tone = 'onDark',
  variant = 'wordmark',
  height = 36,
  className,
}: BrandLogoProps) {
  return (
    <img
      src={SOURCES[tone][variant]}
      alt="Betr"
      draggable={false}
      className={className}
      style={{
        height,
        width: Math.round(height * ASPECT[variant]),
        maxWidth: '100%',
        objectFit: 'contain',
        flexShrink: 0,
        display: 'block',
      }}
    />
  );
}
